import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { EXP_OPTIONS } from '@/entities/enums/LoggersCalibrationExpirationOptions';
const MONTHS_IN_YEAR = 12;
let LoggerSettings = class LoggerSettings extends Vue {
    constructor() {
        super(...arguments);
        this.offlineThreshold = null;
        this.offlineNotification = null;
        this.isEditing = false;
        this.customExpiration = null;
        this.backupCustomExpiration = null;
        this.calibrationExpOptions = EXP_OPTIONS;
    }
    created() {
        this.offlineThreshold = this.secToMinutes(this.departmentSettings.Source.OfflineThreshold);
        this.offlineNotification = this.departmentSettings.Source.DoNotNotifyWhenDeviceOffline;
        this.customExpiration = this.getYearByMonths(this.departmentSettings.Loggers.Calibration.Custom.ExpiresAt);
        this.backupCustomExpiration = this.getYearByMonths(this.departmentSettings.Loggers.Calibration.Custom.ExpiresAt);
    }
    /*
     * check if this feature is allowed in current department
     */
    get customExpirationIsAllowed() {
        return this.tier?.features.find((x) => x.Name === 'Loggers.Calibration.Custom')?.Value?.Allowed === true;
    }
    getYearByMonths(value) {
        return value / MONTHS_IN_YEAR;
    }
    editSettings() {
        this.isEditing = !this.isEditing;
    }
    save() {
        this.$validator.validateAll().then((result) => {
            if (result) {
                if (this.offlineThreshold * 60 != this.departmentSettings.Source.OfflineThreshold)
                    this.$emit('updateLoggerThreshold', this.offlineThreshold * 60);
                if (this.offlineNotification != this.departmentSettings.Source.DoNotNotifyWhenDeviceOffline)
                    this.$emit('updateLoggerNotification', this.offlineNotification);
                if (this.customExpiration)
                    this.$emit('updateCustomExpiration', this.customExpiration * MONTHS_IN_YEAR);
            }
        });
    }
    get hasChanges() {
        return (this.offlineThreshold * 60 != this.departmentSettings.Source.OfflineThreshold ||
            this.offlineNotification != this.departmentSettings.Source.DoNotNotifyWhenDeviceOffline ||
            this.customExpiration != this.getYearByMonths(this.departmentSettings.Loggers.Calibration.Custom.ExpiresAt));
    }
    secToMinutes(seconds) {
        if (seconds)
            return seconds / 60;
        else
            return null;
    }
};
__decorate([
    Prop({ type: Object })
], LoggerSettings.prototype, "departmentSettings", void 0);
__decorate([
    Prop({ type: Object })
], LoggerSettings.prototype, "tier", void 0);
LoggerSettings = __decorate([
    Component({
        components: {}
    })
], LoggerSettings);
export default LoggerSettings;
